// src/utils/session.js

export const isSessionExpired = () => {
    const sessionExpiry = localStorage.getItem('sessionExpiry');
    if (!sessionExpiry) return true; // No session expiry time found, consider session expired
  
    const currentTime = new Date().getTime();
    return currentTime > sessionExpiry;
  };
  